import { z } from 'zod';
/**
 * Known types of identity
 */
export const IdentityType = {
    /**
     * A user associated with a physical person.
     */
    User: 'User',
    /**
     * A machine counterparty.
     */
    Entity: 'Entity',
    /**
     * An anonymous counterparty.
     */
    Anonymous: 'Anonymous',
};
export const IdentityTypeSchema = z.enum(IdentityType);
export const ProTraderStatus = {
    Pro: 'pro',
    NonPro: 'non-pro',
    Unspecified: 'unspecified',
};
export const ProTraderStatusSchema = z.enum(ProTraderStatus);
const ProTraderClaimSchema = z.union([z.boolean(), z.stringbool()]);
const OptionalProTraderClaimSchema = ProTraderClaimSchema.optional();
/**
 * Custom claims we inject on JWTs
 */
export const ThinkAlphaJwtClaims = z.object({
    type: IdentityTypeSchema,
    userId: z.uuid(),
    username: z.string(),
    email: z.string().optional(),
    /** The user's full name; this is preferred to concating given_name and family_name */
    name: z.string().optional(),
    /** First name */
    given_name: z.string().optional(),
    /** Last name */
    family_name: z.string().optional(),
    emailVerified: z.union([z.boolean(), z.stringbool()]).optional(),
    /** @deprecated - use realm_access.roles instead */
    isSuperuser: z.union([z.boolean(), z.stringbool()]).optional(),
    /** @deprecated - use realm_access.roles instead */
    isDeveloper: z.union([z.boolean(), z.stringbool()]).optional(),
    // Not deprecated!
    isTestUser: z.union([z.boolean(), z.stringbool()]).optional(),
    isProTrader: OptionalProTraderClaimSchema,
    realm_access: z
        .object({
        roles: z.array(z.string()).optional(),
    })
        .optional(),
});
export function getProTraderStatusFromJwtClaims(claims) {
    const isProTrader = OptionalProTraderClaimSchema.parse(claims.isProTrader);
    if (isProTrader === true)
        return ProTraderStatus.Pro;
    if (isProTrader === false)
        return ProTraderStatus.NonPro;
    return ProTraderStatus.Unspecified;
}
/**
 * A JWT payload amended by custom internal claims.
 */
export const ThinkAlphaJwtPayload = ThinkAlphaJwtClaims.extend({
    iss: z.string(),
    exp: z.number(),
    iat: z.number(),
});
//# sourceMappingURL=auth.js.map